var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonPersonCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.75C11.0398 3.75 3.75 11.0398 3.75 20C3.75 28.9602 11.0398 36.25 20 36.25C28.9602 36.25 36.25 28.9602 36.25 20C36.25 11.0398 28.9602 3.75 20 3.75ZM16.0766 12.8766C17.0664 11.8273 18.4594 11.25 20 11.25C21.5406 11.25 22.9211 11.8313 23.9148 12.8859C24.9219 13.9547 25.4117 15.3906 25.2961 16.9344C25.0648 20 22.6898 22.5 20 22.5C17.3102 22.5 14.9305 20 14.7039 16.9336C14.5891 15.3773 15.0781 13.9367 16.0766 12.8766ZM20 33.75C18.1644 33.7512 16.3473 33.3838 14.6564 32.6695C12.9655 31.9553 11.4352 30.9089 10.1562 29.5922C10.8887 28.5476 11.822 27.6595 12.9016 26.9797C14.893 25.7031 17.4133 25 20 25C22.5867 25 25.107 25.7031 27.0961 26.9797C28.1765 27.6592 29.1106 28.5474 29.8438 29.5922C28.565 30.909 27.0347 31.9556 25.3437 32.6699C23.6528 33.3841 21.8356 33.7514 20 33.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonPersonCircle);
export default __webpack_public_path__ + "static/media/ion_person-circle.8525262b9109cd698f1b61ced95cba2a.svg";
export { ForwardRef as ReactComponent };